import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  noContentContainer: {
    boxShadow: "0 2px 5px -5px rgba(180, 175, 203, 0.63)",
    backgroundColor: "#fefefe",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    width: "100%",
    height: "100%",
    alignSelf: "center",
    overflowY: "auto"
  },
  noAlertsText: {
    fontSize: "20px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: theme.overrides.MuiButton.outlinedPrimary.color,
    padding: "0 30px"
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px"
  },
  icon: {
    fontSize: "80px",
    color: "#b4afcb",
    opacity: 0.6
  },
  textContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }

}));

export default useStyles;
